import { motion, AnimatePresence } from "framer-motion";
import { useOnlineState } from "@/hooks/useOnline";
import Avatar, { PRESENCE } from "@/components/tracker/Avatar";

const MAX = 8;

export default function OnlineStrip() {
  const { people, ready } = useOnlineState();

  if (!ready) return null;
  const extra = people.length - MAX;
  const onlineCount = people.filter((p) => p.presence === "online").length;
  const awayCount = people.length - onlineCount;
  const summary = !people.length ? "No teammates online"
    : [onlineCount && `${onlineCount} online now`, awayCount && `${awayCount} away`].filter(Boolean).join(" · ");
  return (
    <div className="flex items-center gap-3" data-testid="online-strip">
      <span className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-white/40">
        <span className="relative flex h-2 w-2">
          {onlineCount > 0 && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#00FF66] opacity-60" />}
          <span className={`relative inline-flex h-2 w-2 rounded-full ${onlineCount ? "bg-[#00FF66]" : awayCount ? "bg-[#FFB020]" : "bg-white/20"}`} />
        </span>
        <span data-testid="online-count">{summary}</span>
      </span>
      <div className="flex items-center gap-1.5">
        <AnimatePresence initial={false}>
          {people.slice(0, MAX).map((p, i) => (
            <motion.span
              key={p.id}
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              className="group relative rounded-full bg-[#161616] transition-transform duration-200 hover:-translate-y-0.5"
              data-testid={`online-user-${p.id}`}
            >
              <Avatar name={p.name} size={28} title={`${p.name} · ${PRESENCE[p.presence]?.label || "online now"}`} />
              <span
                className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full ring-2 ring-[#0A0A0A]"
                style={{ backgroundColor: PRESENCE[p.presence]?.color || PRESENCE.online.color }}
                data-testid={`online-user-${p.presence}-${p.id}`}
              />
            </motion.span>
          ))}
        </AnimatePresence>
        {extra > 0 && (
          <span className="flex h-7 min-w-7 items-center justify-center rounded-full bg-white/10 px-1.5 text-[10px] font-bold text-white/70" title={people.slice(MAX).map((p) => p.name).join(", ")} data-testid="online-more">
            +{extra}
          </span>
        )}
      </div>
    </div>
  );
}
